import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import useAppContext from 'flow/hooks/useAppContext';
import {
    getGoToOmniChannelErrandPayload,
    getCentionUrl,
} from 'flow/utils/omnichannel-utils';
import { addOmniChannelLogEntry } from 'flow/utils/browser-utils';
import { navigateTo } from 'flow/actions/navigate-actions';
import Icon from '../ui-components/Icon';

const getServiceNameComponent = (i18next) => {
    return (
        <>
            <div className="flex min-w-9 content-center items-center text-gray-400">
                <Icon iconKey={'omni-queue'} className="h-18 min-h-4 p-2" />
            </div>
            {i18next.t('Go to errand')}
        </>
    );
};

const goToCentionErrand = (
    centionUrl,
    deeplink,
    iframeRef,
    navigateToCentionTabPath,
) => {
    const payload = getGoToOmniChannelErrandPayload(deeplink);
    addOmniChannelLogEntry(
        `User pressed Go to Cention ticket button, sending postMessage with payload: ${payload}`,
    );
    try {
        iframeRef.contentWindow.postMessage(payload, centionUrl);
        navigateToCentionTabPath();
    } catch (error) {
        addOmniChannelLogEntry(
            `Failed sending postMessage with error: ${error}`,
        );
    }
};

const CentionErrandWidget = ({
    centionUrl,
    deeplink,
    iframeRef,
    navigateToCentionTabPath,
}) => {
    const { i18next } = useAppContext();

    return (
        <div
            className="flex cursor-pointer items-center justify-between overflow-hidden rounded-xs bg-gray-800 text-center text-ellipsis whitespace-nowrap"
            onClick={() =>
                goToCentionErrand(
                    centionUrl,
                    deeplink,
                    iframeRef,
                    navigateToCentionTabPath,
                )
            }
        >
            <div className="flex content-start items-center overflow-hidden text-xs font-light text-ellipsis whitespace-nowrap text-gray-400">
                <div className="me-2 flex content-center items-center overflow-hidden text-xs font-light tracking-wide text-ellipsis whitespace-nowrap text-gray-400">
                    {getServiceNameComponent(i18next)}
                </div>
            </div>
        </div>
    );
};

CentionErrandWidget.propTypes = {
    centionUrl: PropTypes.string.isRequired,
    deeplink: PropTypes.string.isRequired,
    iframeRef: PropTypes.instanceOf(Element),
    navigateToCentionTabPath: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    const iframeRef = state.omnichannel.get('iframeRef');
    const centionUrl = getCentionUrl(state);
    return { centionUrl, iframeRef };
};

const dispatchProps = {
    navigateToCentionTabPath: () => navigateTo('/omni'),
};

export default connect(mapStateToProps, dispatchProps)(CentionErrandWidget);
